// extracted by mini-css-extract-plugin
export default {"container":"RXDHq","header":"UVejx","main":"BxtzY","badges":"bAJnQ"};